import { Page } from 'Common/Page/Page'
import { PageHeader } from 'Common/Supplyvue-ui'
import { Box } from '@mui/material'

export const ProductGroupingView = () => {
  return (
    <Page>
      <Box display="flex" flexDirection="column" justifyContent="flex-start">
        <PageHeader title="Product Grouping" />
      </Box>
    </Page>
  )
}
